import { qs, qsa, remove, add, listen } from '@fluorescent/dom';

import { section } from '@/glow';
import { on, emit } from '@/glow/events';
import navigationDots from '@/lib/navigation-dots';

section('quotes', {
  events: [],
  listeners: [],
  onLoad() {
    const { autoplay } = this.container.dataset;
    const sliderEl = qs('.js-fq', this.container);
    let dotNavigation = null;

    import('flickity').then(({ default: Flickity }) => {
      this.pagination = qsa('[data-pagination]', this.container);
      this.slideshow = new Flickity(sliderEl, {
        adaptiveHeight: false,
        autoPlay: parseInt(autoplay, 10),
        pageDots: false,
        prevNextButtons: false,
        wrapAround: true,
        adaptiveHeight: true,
      });
      emit('quotes:initialized');

      this.handlePagination = ({ currentTarget }) => {
        const trigger = qs('.quotes__icon', currentTarget);
        const { index } = trigger.dataset;
        this.slideshow.pausePlayer();
        this.slideshow.select(index);
      };

      if (Boolean(this.pagination.length)) {
        this.slideshow.on('change', index => {
          this.pagination.forEach(el => {
            remove(qs('.quotes__icon', el), 'active');
          });

          add(
            qs(`.quotes__icon[data-index="${index}"]`, this.container),
            'active'
          );
        });

        this.pagination.forEach(el =>
          this.events.push(listen(el, 'click', this.handlePagination))
        );
      }

      if (qs('.navigation-dots', this.container)) {
        dotNavigation = navigationDots(this.container, this.slideshow);

        this.slideshow.on('select', () => {
          dotNavigation.update(this.slideshow.selectedIndex);
        });
      }
    });
  },

  handleBlockSelect(slideIndex) {
    this.slideshow.pausePlayer();
    this.slideshow.select(slideIndex);
  },

  onUnload() {
    this.slideshow.destroy();
    this.events.forEach(unsubscribe => unsubscribe());
  },

  onBlockSelect({ target }) {
    if (this.slideshow) {
      this.handleBlockSelect(target.dataset.index);
    } else {
      // Listen for initalization if slideshow does not exist
      this.listeners.push(
        on('quotes:initialized', () => {
          this.handleBlockSelect(target.dataset.index);
        })
      );
    }
  },

  onBlockDeselect() {
    if (this.slideshow) {
      this.slideshow.unpausePlayer();
    } else {
      // Listen for initalization if slideshow does not exist
      this.listeners.push(
        on('quotes:initialized', () => {
          this.slideshow.unpausePlayer();
        })
      );
    }
  },
});
